import moment from 'moment'
import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
import FirestoreUtils from '@/plugins/Utils/FirestoreUtils'
import { firebase } from '@firebase/app'
const { Timestamp } = firebase.firestore
const QDATEDEFAULTFORMAT = 'DD/MM/YYYY'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [Object, String]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: [Object, String]
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      dateFormat: this.config.format ? this.config.format : this.$store.state.config.defaultDateFormat,
      value: '',
      rawDate: this.modelProps && this.modelProps instanceof Timestamp ? moment( this.modelProps.toDate()).format(QDATEDEFAULTFORMAT) : '',
      closePopup: false,
      innerModel: null,
      qDateDefaultFormat: QDATEDEFAULTFORMAT,
      message: 'Please input valid date format',
      rules: this.config.validation ? this.config.validation : null,
      moment,
      range: ''
    }
  },
  created () {
    if(!this.rules) {
      this.rules = 'date_format:dd/MM/yyyy'
    } else if(typeof this.rules === 'string') {
      this.rules += '|date_format:dd/MM/yyyy'
    } else if(typeof this.rules === 'object') {
      this.rules.date_format = 'dd/MM/yyyy'
    }
    this.value = this.modelProps && this.modelProps instanceof Timestamp ? moment(this.modelProps.toDate()).format(this.dateFormat) : ''
    if (!this.R.isNil(this.value) && !(this.value instanceof Timestamp) && typeof this.value === 'object') {
      let converted = FirestoreUtils.convertJsonToTimetamp(this.value)
      this.value = moment(converted instanceof Timestamp ? converted.toDate() : '').format(this.dateFormat)
    }
    let vm = this
    vm.config.format = vm.config.format ? vm.config.format : vm.$store.state.config.defaultDateFormat
    // eslint-disable-next-line
    this.range = eval(this.internalScaffolding.range)
  },
  watch: {
    rawDate (newVl, oldVl) {
      // RawDate from date picker quasar always YYYY/MM/DD
      if (!newVl || this._.isEmpty(newVl)) {
        this.$emit('input', null)
        return
      }
      this.$emit('input', Timestamp.fromDate(new Date(moment.utc(newVl, this.qDateDefaultFormat).format())))
      if(this.R.path(['$refs', 'qdate', 'innerModel'], this)) {
        this.innerModel = this._.cloneDeep(this.$refs['qdate'].innerModel)
        this.value = moment(newVl, this.qDateDefaultFormat).format(this.dateFormat)
        let newVlMoment = moment(newVl, this.qDateDefaultFormat)
        let oldVlMoment = moment(oldVl, this.qDateDefaultFormat)
        this.closePopup = oldVl ? (newVlMoment.date() !== oldVlMoment.date() ? true : newVlMoment.month() !== oldVlMoment.month() || newVlMoment.year() !== oldVlMoment.year()) : newVlMoment.month() + 1 === this.innerModel.month && newVlMoment.year() === this.innerModel.year
      }
    },
    value (newValue) {
      this.rawDate = newValue
    }
  },
  methods: {
    validDate(stringTyped) {
      let check = moment(stringTyped, this.dateFormat).isValid() && stringTyped.length === 10
      if(!check && !this.$validator.errors.has(this.config.fieldName, this.config.vvScope)) {
        this.$validator.errors.add({
          field: this.config.fieldName,
          msg: this.message,
          scope: this.config.vvScope,
          id: this._uid
        })
      }
      return check
    },
    validate () {
      if(this.$refs[this._uid]) {
        this.$refs[this._uid].$emit('submitEvent', this.value)
      }
    }
  }
}
